export enum CreditSafePortfolioEventStatus {
    Pending = 'pending',
    Processed = 'processed',
    Failed = 'failed',
    Skipped = 'skipped',
}
